export default __webpack_public_path__ + "static/media/collapse.3bb1e23e.svg";